import { createAsyncThunk } from '@reduxjs/toolkit';
import { GROUP_NAME, ThunkApi, User } from '@greenkub-fronts/shared/interface';

type LoginWithTokenRequest = {
  token: string;
};

type LoginResponse = {
  email: string;
  token: string;
  profile: User;
};

export const loginWithToken = createAsyncThunk<
  LoginResponse,
  LoginWithTokenRequest,
  ThunkApi
>('loginWithToken', async (data, { dispatch, extra }) => {
  const profileResp = await dispatch(
    extra.apiSlice.endpoints.getProfile.initiate(
      {
        token: data.token,
        groupName: GROUP_NAME.PROFILE,
      },
      { forceRefetch: true }
    )
  );

  localStorage.setItem(
    'auth',
    JSON.stringify({
      email: profileResp.email,
      token: data.token,
      user: profileResp.data,
    })
  );

  return {
    email: profileResp.email,
    token: data.token,
    profile: profileResp.data,
  } as LoginResponse;
});
